import React from 'react'
import { useTranslation } from 'react-i18next';
import { Box, Typography, Link, List, ListItem, Divider } from '@mui/material'
import { Helmet } from "react-helmet";
import MainLayout from '../../components/MainLayout'
import StaticPagesWrapper from '../../components/StaticPagesWrapper'
import ListItemHeader from '../../components/StaticPagesWrapper/ListItemHeader'

function Section({ title, children }) {
    const id = slugify(title);
    return (
        <Box component="section" id={id} sx={{ scrollMarginTop: 96 }}>
            <ListItemHeader>
                {title}
            </ListItemHeader>
            {children}
        </Box>
    );
}


function slugify(str) {
    return String(str)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // quitar acentos
        .replace(/[^a-z0-9\s.-]/g, "")
        .trim()
        .replace(/\s+/g, "-");
}

const PrivacyPolicies = () => {

    const { i18n } = useTranslation();
    const lng = i18n.language || 'en';

    if (lng == 'es') {
        return (
            <MainLayout>
                <Helmet>
                    <title>Política de Privacidad - ToursPrivados</title>
                    <meta
                        name="description"
                        content="Política de Privacidad de TREKZY"
                        data-react-helmet="true"
                    />
                </Helmet>

                <StaticPagesWrapper title="ToursPrivados">
                    <Box mb={8}>
                        <ListItemHeader styles={{ padding: 0 }}>
                            POLÍTICA DE PRIVACIDAD
                        </ListItemHeader>

                        <Typography variant="body1" paragraph>
                            Siguiendo los principios de licitud, lealtad y transparencia, ponemos a su disposición la presente Política de Privacidad.
                        </Typography>

                        <Divider sx={{ my: 3 }} />

                        <Section title="¿QUIÉN ES EL RESPONSABLE DEL TRATAMIENTO DE SUS DATOS PERSONALES?">
                            <ListItemHeader>
                                IDENTIDAD Y DATOS DEL RESPONSABLE
                            </ListItemHeader>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>Tours Privados SL (en lo sucesivo, <strong>“TREKZY”</strong>)</ListItem>
                                <ListItem sx={{ display: 'list-item' }}><strong>CIF:</strong> B75873927</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>DOMICILIO SOCIAL:</strong> Pasaje de Bisbal 6 1ª Planta, 28028 Madrid España
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    <strong>CONTACTO:</strong> <Link href="mailto:info@trekzy.com">info@trekzy.com</Link>
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}><strong>TELÉFONO:</strong> (+34) 91 75 78 557</ListItem>
                            </List>
                        </Section>

                        <Section title="¿CON QUÉ FINALIDAD TRATAMOS SUS DATOS PERSONALES?">
                            <Typography variant="body1" paragraph>
                                Esta Política de Privacidad tiene por objeto brindar información sobre el tratamiento de los datos personales (en lo sucesivo, los <strong>“Datos Personales”</strong>) de aquellas personas físicas o morales que contratan los servicios de TREKZY que ofrece a través de los sitios web de su propiedad:{" "}
                                <Link href="https://www.trekzy.com" target="_blank" rel="noopener">www.trekzy.com</Link>{" "}
                                y{" "}
                                <Link href="https://www.toursprivados.com" target="_blank" rel="noopener">www.toursprivados.com</Link>{" "}
                                (el <strong>“Sitio Web”</strong>) y/o que solicitan información sobre los términos y condiciones de nuestros servicios y/o que tienen relación comercial, profesional y/o laboral con TREKZY.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Esta Política de Privacidad resulta aplicable a la recogida de Datos Personales efectuada a través de nuestro Sitio Web o cualquier otro medio y al tratamiento de dicha información cuando ha sido obtenida por TREKZY a través de otras fuentes legalmente reconocidas.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                En TREKZY, dependiendo de la categoría de interesado de que se trate, tratamos la información que nos facilita con las siguientes finalidades:
                            </Typography>
                        </Section>

                        <Section title="¿QUÉ DATOS PERSONALES RECABAMOS?">
                            <Typography variant="body1" paragraph>
                                Para el cumplimiento de las finalidades anteriormente relacionadas, TREKZY según el tipo de interesado podrá recoger y tratar las siguientes categorías de Datos Personales:
                            </Typography>

                            <ListItemHeader>
                                CLIENTES/POTENCIALES CLIENTES/USUARIOS DEL SITIO WEB:
                            </ListItemHeader>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>Nombre y apellidos (y de sus acompañantes)</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Número de documento nacional de identidad (en ciertos casos y en caso de que los servicios lo requieran)
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Correo electrónico</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Datos bancarios</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Información de contacto</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Datos relativos a la salud, cuando el interesado los proporciona de manera expresa y voluntaria para obtener una prestación de servicios que requiere tomar en cuenta, precisamente, el estado de salud de dicho interesado o de uno o más de sus acompañantes.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Dirección de protocolo de internet (IP)</ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                TREKZY no trata Datos Personales para elaborar perfiles de sus clientes o prospectos, ni utiliza tecnologías para la adopción de decisiones individuales automatizadas.
                            </Typography>

                            <ListItemHeader>
                                EMPLEADOS Y CANDIDATOS:
                            </ListItemHeader>
                            <Typography variant="body1" paragraph>
                                Con el fin de (i) gestionar, controlar y administrar los currículums de candidatos a puestos de trabajo bajo demanda o espontáneamente por interesados; (ii) generar perfiles de candidatos para entrevistas de trabajo; y/o (iii) ofrecer términos y condiciones de contratación a empleados y candidatos dentro de los procesos de selección desarrollados por TREKZY y conforme a sus políticas de contratación, se podrán recoger, entre otros, los siguientes Datos Personales:
                            </Typography>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>Nombre y apellidos</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Número de documento nacional de identidad</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Correo electrónico</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Género</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Domicilio</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Datos bancarios</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Información de contacto</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Datos relativos a la salud</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Datos académicos y/o profesionales</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Datos económicos, financieros y de seguros</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Certificado de antecedentes penales</ListItem>
                            </List>

                            <ListItemHeader>
                                PROVEEDORES:
                            </ListItemHeader>
                            <Typography variant="body1" paragraph>
                                Con el fin de que TREKZY este en posibilidad de garantizar la calidad de los servicios a sus clientes y gestionar y administrar la relación comercial con los proveedores de TREKZY podremos recoger los siguientes Datos Personales:
                            </Typography>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Nombre y apellidos en caso de ser persona física y documentación de legal existencia en caso de ser persona jurídica
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Número de documento nacional de identidad</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Correo electrónico</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Género; en caso de ser persona física</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Domicilio</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Datos bancarios</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Información de contacto</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Certificado de antecedentes penales</ListItem>
                            </List>

                            <ListItemHeader>
                                DATOS PERSONALES DE MENORES DE EDAD
                            </ListItemHeader>
                            <Typography variant="body1" paragraph>
                                TREKZY no recaba Datos Personales de menores de edad de manera directa ni personal. Nuestros servicios están dirigidos a mayores de edad, quienes podrán facilitar los datos personales de menores de edad que los acompañen y sobre los cuales ejerzan la patria potestad o la tutela correspondiente.
                            </Typography>
                        </Section>

                        <Section title="INTERESADOS; FINALIDADES DEL TRATAMIENTO">
                            <Typography variant="body1" paragraph>
                                <strong>POTENCIALES CLIENTES:</strong> Gestionar la potencial relación comercial y/o profesional, gestionar el envío de información solicitada y/o resolver las consultas planteadas, facilitar ofertas de nuestros servicios y/o productos de su interés.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>CLIENTES:</strong> Gestionar la relación comercial y/o profesional, facilitar ofertas de nuestros servicios y/o productos de su interés.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                Para la prestación de los servicios contratados, debemos comunicar sus Datos Personales con el fin de asegurar que estos se proporcionen en las fechas y para las personas que los han contratado a través de TREKZY y/o del Sitio Web. Si Usted decide que no desea comunicar sus Datos Personales y/o el de sus acompañantes, es posible que no podamos prestarle el servicio o garantizar su disponibilidad.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>PROVEEDORES:</strong> Gestionar la relación comercial y/o profesional con TREKZY.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>EMPLEADOS Y CANDIDATOS:</strong> Gestionar el proceso de selección y contratación de personal con TREKZY; gestionar y administrar la relación laboral con TREKZY; gestionar y administrar los expedientes laborales de los empleados y colaboradores de TREKZY, incluyendo el pago de nómina; y gestionar, controlar y administrar medidas para el cumplimiento de obligaciones laborales incluyendo las relacionadas con prevención de riesgos laborales, incluyendo, en su caso, medicina preventiva o laboral.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>USUARIOS DEL SITIO WEB:</strong> Gestionar el análisis de sus datos de navegación en el Sitio Web.
                            </Typography>
                        </Section>

                        <Section title="¿CUÁL ES LA LEGITIMACIÓN PARA EL TRATAMIENTO DE SUS DATOS PERSONALES?">
                            <Typography variant="body1" paragraph>
                                La base legal para el tratamiento de sus Datos Personales, dependiendo de la categoría de interesado de que se trate, puede ser:
                            </Typography>

                            <ListItemHeader>
                                INTERESADOS BASE LEGAL
                            </ListItemHeader>

                            <Typography variant="body1" paragraph>
                                POTENCIALES CLIENTES:
                            </Typography>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Art. 6.1.b RGPD: aplicación, a petición del interesado, de medidas precontractuales (cotizaciones, presupuestos, hojas de encargo, ofertas de servicios…).
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Art. 6.1.f RGPD: Interés legítimo (enviar información solicitada, responder a las consultas planteadas…).
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Art. 6.1.a RGPD: consentimiento del propio interesado (facilitar ofertas de nuestros servicios y/o productos).
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                CLIENTES:
                            </Typography>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Art. 6.1.b RGPD: ejecución de un contrato de servicios en el que el interesado es parte.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                PROVEEDORES:
                            </Typography>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Art. 6.1.b RGPD: ejecución de un contrato en el que el interesado es parte.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                EMPLEADOS Y CANDIDATOS:
                            </Typography>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Art. 6.1.a RGPD: consentimiento del propio interesado.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                USUARIOS DEL SITIO WEB:
                            </Typography>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Art. 6.1.a RGPD: consentimiento del propio interesado.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                Los Datos Personales que le solicitamos son adecuados, pertinentes y estrictamente necesarios y en ningún caso está obligado a facilitárnoslos, pero su no comunicación (i) podrá afectar a la finalidad del servicio o la imposibilidad de prestarlo si Usted es cliente de TREKZY; (ii) impedirá la ejecución de un contrato de servicios si usted es proveedor; o (iii) impedira la continuación de un proceso de contratación si usted es un candidato.
                            </Typography>
                        </Section>

                        <Section title="¿POR CUÁNTO TIEMPO CONSERVAREMOS SUS DATOS PERSONALES?">
                            <Typography variant="body1" paragraph>
                                Sus Datos Personales, serán conservados el tiempo mínimo necesario para la correcta prestación del servicio ofrecido, así como para atender las responsabilidades que se pudieran derivar del mismo y de cualquier otra exigencia legal y de manera indefinida para el envío de ofertas de nuestros servicios y otras comunicaciones.
                            </Typography>
                        </Section>

                        <Section title="¿A QUÉ DESTINATARIOS SE COMUNICARÁN SUS DATOS?">
                            <Typography variant="body1" paragraph>
                                TREKZY, no comunicará ni transmitirá sus Datos Personales a ningún tercero, salvo que se informe de ello expresamente.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Adicionalmente le informamos que determinados Datos Personales, en virtud de la normativa vigente o de la relación contractual que mantenga con TREKZY, podrán ser comunicados a:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>Agencias de Viajes con las que tenemos relación contractual para ofrecerle nuestros servicios.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Proveedores de transporte con los que tenemos relación contractual para ofrecerle nuestros servicios.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Personas físicas y personas jurídicas que prestan servicios turísticos bajo demanda y coordinación de TREKZY.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Establecimientos o destinos turísticos que requieren de manera expresa la identidad de usuarios o visitantes.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Los bancos y entidades financieras para el cobro de los servicios contratados y/o productos comprados.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Administraciones públicas con competencia en los sectores de la actividad de TREKZY, cuando así lo establezca la normativa vigente.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Entidades afiliadas o subsidiarias de TREKZY dentro o fuera de la Unión Europea.</ListItem>
                            </List>
                        </Section>

                        <Section title="¿CUÁLES SON SUS DERECHOS CUANDO NOS FACILITA SUS DATOS?">
                            <Typography variant="body1" paragraph>
                                Los derechos de protección de Datos Personales que podrán ejercer los interesados, cuando procedan, son:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>Derecho a solicitar el acceso a los Datos Personales relativos al interesado.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Derecho de rectificación o supresión.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Derecho de oposición.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Derecho a solicitar la limitación de su tratamiento.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Derecho a la portabilidad de los Datos Personales.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Derecho a no ser objeto de decisiones basadas únicamente en el tratamiento automatizado de Datos Personales.</ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                Los titulares de los Datos Personales obtenidos podrán ejercer sus derechos de protección de datos personales dirigiendo una comunicación por escrito al domicilio social de TREKZY, o al correo electrónico habilitado a tal efecto{" "}
                                <Link href="mailto:datospersonales@trekzy.com">datospersonales@trekzy.com</Link>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Modelos, formularios y más información disponible sobre sus derechos en la página web de la autoridad de control nacional, Agencia Española de Protección de Datos, en adelante, AEPD,{" "}
                                <Link href="https://www.aepd.es" target="_blank" rel="noopener">www.aepd.es</Link>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                TREKZY dará respuesta dentro del plazo de un mes a partir de la recepción de su solicitud y, en casos excepcionales, dicho plazo podrá prorrogarse hasta por otros dos.
                            </Typography>
                        </Section>

                        <Section title="¿PUEDO RETIRAR EL CONSENTIMIENTO?">
                            <Typography variant="body1" paragraph>
                                Usted tiene la posibilidad y el derecho a retirar el consentimiento para cualquier finalidad específica otorgada en su momento, sin que ello afecte a la licitud del tratamiento basado en el consentimiento previo a su retirada.
                            </Typography>
                        </Section>

                        <Section title="¿DÓNDE PUEDO RECLAMAR EN CASO DE QUE CONSIDERE QUE NO SE TRATAN MIS DATOS PERSONALES CORRECTAMENTE?">
                            <Typography variant="body1" paragraph>
                                Si algún interesado considera que sus Datos Personales no son tratados correctamente por TREKZY, o que las solicitudes de ejercicio de derechos no han sido atendidas de forma satisfactoria, puede interponer una reclamación ante a la autoridad de protección de datos que corresponda, siendo la AEPD la indicada en el territorio nacional,{" "}
                                <Link href="https://www.aepd.es" target="_blank" rel="noopener">www.aepd.es</Link>.
                            </Typography>
                        </Section>

                        <Section title="SEGURIDAD Y ACTUALIZACIÓN DE SUS DATOS PERSONALES">
                            <Typography variant="body1" paragraph>
                                Con el objetivo de salvaguardar la seguridad de sus Datos Personales, le informamos que TREKZY ha adoptado todas las medidas de índole técnica y organizativa necesarias para garantizar la seguridad de los Datos Personales suministrados. Todo ello para evitar su alteración, pérdida, y/o tratamientos o accesos no autorizados, tal como exige la normativa, si bien la seguridad absoluta no existe.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                Es importante que, para que podamos mantener sus Datos Personales actualizados, nos informe siempre que se produzca una modificación de los mismos.
                            </Typography>
                        </Section>

                        <Section title="TRANSFERENCIAS INTERNACIONALES">
                            <ListItemHeader>
                                CLIENTES/POTENCIALES CLIENTES/USUARIOS DEL SITIO WEB:
                            </ListItemHeader>
                            <Typography variant="body1" paragraph>
                                Para las finalidades indicadas en la presente Política de Privacidad, TREKZY no realiza transferencia de Datos Personales fuera del territorio de la Unión Europea.
                            </Typography>

                            <ListItemHeader>
                                PROVEEDORES/CANDIDATOS/EMPLEADOS:
                            </ListItemHeader>
                            <Typography variant="body1" paragraph>
                                Para las finalidades de gestión y administración indicadas en la presente Política de Privacidad, TREKZY realiza transferencias de sus datos personales fuera del territorio de la Unión Europea, con destino hacia los Estados Unidos Mexicanos.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                En virtud de que el destino de la transferencia no cuenta con una decisión de adecuación por parte de la Comisión Europea, TREKZY ha adoptado con el destinario de los datos personales Amigo Group Europa, S.L. medidas para garantizar un nivel adecuado de protección a esa información, consistentes en la celebración entre las partes de cláusulas contractuales tipo de protección de datos adoptadas por la Comisión Europea. Usted puede obtener una copia de la versión pública de estas garantías adecuadas dirigiendo una solicitud a{" "}
                                <Link href="mailto:datospersonales@trekzy.com">datospersonales@trekzy.com</Link>.
                            </Typography>
                        </Section>

                        <Section title="CONFIDENCIALIDAD">
                            <Typography variant="body1" paragraph>
                                TREKZY le informa que sus Datos Personales serán tratados con el máximo celo y confidencialidad por todo el personal que intervenga en cualquiera de las fases del tratamiento. No cederemos ni comunicaremos a ningún tercero sus datos, excepto en los casos legalmente previstos, o salvo que el interesado nos hubiera autorizado expresamente.
                            </Typography>
                        </Section>

                        <Section title="MODIFICACIONES Y ACTUALIZACIONES DE LA PRESENTE POLÍTICA DE PRIVACIDAD">
                            <Typography variant="body1" paragraph>
                                TREKZY podrá modificar, ampliar, corregir o actualizar la presente Política de Privacidad, en cualquier momento y bajo su completa responsabilidad. En todos los casos, publicaremos en el Sitio Web la fecha de última actualización de esta Política de Privacidad.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                Podremos comunicar estos cambios a través del Sitio o mediante el envío de un correo electrónico en caso de contar con su dirección, pero sin estar obligado a ello.
                            </Typography>
                        </Section>

                        <Divider sx={{ my: 4 }} />
                        <Typography variant="body2" color="text.secondary" paragraph>
                            Última actualización: 04 de diciembre de 2024
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Pasaje de Bisbal 6, 28028, Madrid (España)
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            <Link href="https://www.trekzy.com" target="_blank" rel="noopener">
                                www.trekzy.com
                            </Link>
                        </Typography>
                    </Box>
                </StaticPagesWrapper>
            </MainLayout>
        );
    } else {
        return (
            <MainLayout>
                <Helmet>
                    <title>Privacy Policy - Trekzy</title>
                    <meta
                        name="description"
                        content="Privacy Policy for TREKZY websites and services"
                        data-react-helmet="true"
                    />
                </Helmet>

                <StaticPagesWrapper title="Trekzy">
                    <Box mb={8}>
                        <ListItemHeader styles={{ padding: 0 }}>
                            PRIVACY POLICY
                        </ListItemHeader>

                        <Typography variant="body1" paragraph>
                            Following the principles of legality, fairness, and transparency, we make this Privacy Policy available to you.
                        </Typography>

                        <Divider sx={{ my: 3 }} />

                        <Section title="WHO IS CONTROLLER OF YOUR PERSONAL DATA?">
                            <ListItemHeader>
                                IDENTITY AND DETAILS OF THE CONTROLLER
                            </ListItemHeader>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>Tours Privados SL (hereinafter, &quot;TREKZY&quot;)</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>CIF: B75873927</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    REGISTERED OFFICE: Pasaje de Bisbal 6, 1st Floor, 28028 Madrid, Spain
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    CONTACT: <Link href="mailto:info@trekzy.com">info@trekzy.com</Link>
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>PHONE: (+34) 91 75 78 557</ListItem>
                            </List>
                        </Section>

                        <Section title="FOR WHAT PURPOSE DO WE PROCESS YOUR PERSONAL DATA?">
                            <Typography variant="body1" paragraph>
                                The purpose of this Privacy Policy is to provide information about the processing of personal data
                                (hereinafter, &quot;Personal Data&quot;) of individuals or legal entities who contract TREKZY services
                                offered through its websites: www.trekzy.com and www.toursprivados.com (the &quot;Website&quot;) and/or who
                                request information about the terms and conditions of our services and/or who have a commercial,
                                professional, and/or employment relationship with TREKZY.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                This Privacy Policy applies to the collection of Personal Data through our Website or any other means and
                                to the processing of such information when obtained by TREKZY through other legally recognized sources.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                At TREKZY, depending on the category of data subject, we process the information you provide for the
                                following purposes:
                            </Typography>
                        </Section>

                        <Section title="WHAT PERSONAL DATA DO WE COLLECT?">
                            <Typography variant="body1" paragraph>
                                To fulfill the aforementioned purposes, TREKZY, depending on the type of data subject, may collect and
                                process the following categories of Personal Data:
                            </Typography>

                            <ListItemHeader>
                                CLIENTS/POTENTIAL CLIENTS/WEBSITE USERS:
                            </ListItemHeader>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>First and last name (and those of their companions)</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    National identity document number (in certain cases and if the services require it)
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Email address</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Bank details</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Contact information</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Health-related data, when the data subject expressly and voluntarily provides it to obtain services that
                                    require specific consideration of the health status of said data subject or one or more of their
                                    companions.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Internet Protocol (IP) address</ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                TREKZY does not process Personal Data to create profiles of its clients or prospects, nor does it use
                                technologies for automated individual decision-making.
                            </Typography>

                            <ListItemHeader>
                                EMPLOYEES AND CANDIDATES:
                            </ListItemHeader>
                            <Typography variant="body1" paragraph>
                                For the purposes of (i) managing, controlling, and administering the resumes of job candidates on demand
                                or spontaneously submitted by interested parties; (ii) generating candidate profiles for job interviews;
                                and/or (iii) offer hiring terms and conditions to employees and candidates within the selection processes
                                developed by TREKZY and in accordance with its hiring policies, the following Personal Data may be
                                collected, among others:
                            </Typography>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>First and last name</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>National identity document number</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Email address</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Gender</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Address</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Banking information</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Contact information</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Health-related information</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Academic and/or professional information</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Economic, financial, and insurance information</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Criminal record certificate</ListItem>
                            </List>

                            <ListItemHeader>
                                SUPPLIERS:
                            </ListItemHeader>
                            <Typography variant="body1" paragraph>
                                In order for TREKZY to guarantee the quality of services to its clients and manage and administer the
                                commercial relationship with TREKZY&apos;s suppliers, we may collect the following Personal Data:
                            </Typography>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    First and last name in the case of an individual and legally valid documentation in the case of a legal
                                    entity
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>National identity document number</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Email address</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Gender; If you are an individual,</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Address</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Bank details</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Contact information</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>Criminal record certificate</ListItem>
                            </List>

                            <ListItemHeader>
                                PERSONAL DATA OF MINORS
                            </ListItemHeader>
                            <Typography variant="body1" paragraph>
                                TREKZY does not collect Personal Data from minors directly or personally. Our services are intended for
                                adults, who may provide the personal data of minors accompanying them and over whom they exercise parental
                                authority or corresponding guardianship.
                            </Typography>
                        </Section>

                        <Section title="INTERESTED PARTIES; PURPOSES OF PROCESSING">
                            <Typography variant="body1" paragraph>
                                POTENTIAL CLIENTS: Manage the potential commercial and/or professional relationship, manage the sending of
                                requested information and/or resolve queries, provide offers for our services and/or products of interest.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                CLIENTS: Manage the commercial and/or professional relationship, provide offers for our services and/or
                                products of interest.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                To provide the contracted services, we must share your Personal Data to ensure that they are provided on
                                the dates and to the people who have contracted them through TREKZY and/or the Website. If you decide not
                                to share your Personal Data and/or that of your companions, we may not be able to provide the service or
                                guarantee its availability.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                SUPPLIERS: Manage the commercial and/or professional relationship with TREKZY.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                EMPLOYEES AND CANDIDATES: Manage the selection and hiring process with TREKZY; manage and administer the
                                employment relationship with TREKZY; manage and administer the employment records of TREKZY employees and
                                collaborators, including payroll payments; and manage, monitor, and administer measures for compliance
                                with employment obligations, including those related to occupational risk prevention, including, where
                                applicable, preventive or occupational medicine.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                WEBSITE USERS: Manage the analysis of your browsing data on the Website.
                            </Typography>
                        </Section>

                        <Section title="WHAT IS THE LEGAL BASIS FOR PROCESSING YOUR PERSONAL DATA?">
                            <Typography variant="body1" paragraph>
                                The legal basis for processing your Personal Data, depending on the category of data subject, may be:
                            </Typography>

                            <ListItemHeader>
                                INTERESTED PARTIES LEGAL BASIS
                            </ListItemHeader>

                            <Typography variant="body1" paragraph>
                                POTENTIAL CLIENTS:
                            </Typography>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Art. 6.1.b GDPR: Application, at the request of the interested party, of pre-contractual measures
                                    (quotes, estimates, order forms, service offers, etc.).
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Art. 6.1.f GDPR: Legitimate interest (sending requested information, responding to queries, etc.).
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Art. 6.1.a GDPR: consent of the interested party (providing offers for our services and/or products).
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                CLIENTS:
                            </Typography>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Art. 6.1.b GDPR: Performance of a service contract to which the interested party is a party.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                SUPPLIERS:
                            </Typography>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Art. 6.1.b GDPR: Performance of a contract to which the interested party is a party.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                EMPLOYEES AND CANDIDATES:
                            </Typography>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>Art. 6.1.a GDPR: consent of the interested party.</ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                WEBSITE USERS:
                            </Typography>
                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>Art. 6.1.a GDPR: consent of the data subject.</ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                The Personal Data we request from you is adequate, relevant, and strictly necessary, and under no
                                circumstances are you obliged to provide it. However, failure to provide it (i) may affect the purpose of
                                the service or make it impossible to provide it if you are a TREKZY customer; (ii) prevent the execution of
                                a service contract if you are a supplier; or (iii) prevent the continuation of a recruitment process if you
                                are a candidate.
                            </Typography>
                        </Section>

                        <Section title="HOW LONG WILL WE RETAIN YOUR PERSONAL DATA?">
                            <Typography variant="body1" paragraph>
                                Your Personal Data will be retained for the minimum period necessary to properly provide the service
                                offered, as well as to meet any responsibilities that may arise from it and any other legal requirement,
                                and indefinitely for the purpose of sending offers for our services and other communications.
                            </Typography>
                        </Section>

                        <Section title="TO WHICH RECIPIENTS WILL YOUR DATA BE DISCLOSED?">
                            <Typography variant="body1" paragraph>
                                TREKZY will not share or transmit your Personal Data to any third party unless expressly informed otherwise.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                We also inform you that certain Personal Data, pursuant to current regulations or the contractual
                                relationship you maintain with TREKZY, may be disclosed to:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Travel agencies with whom we have a contractual relationship to offer you our services.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Transportation providers with whom we have a contractual relationship to offer you our services.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Individuals and legal entities that provide tourist services on demand and coordinated by TREKZY.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Tourist establishments or destinations that expressly require the identity of users or visitors.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Banks and financial institutions for payment of contracted services and/or purchased products.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Public administrations with jurisdiction in TREKZY&apos;s sectors of activity, when so established by
                                    current regulations.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Affiliated or subsidiary entities of TREKZY within or outside the European Union.
                                </ListItem>
                            </List>
                        </Section>

                        <Section title="WHAT ARE YOUR RIGHTS WHEN YOU PROVIDE US WITH YOUR DATA?">
                            <Typography variant="body1" paragraph>
                                The Personal Data protection rights that data subjects may exercise, where applicable, are:
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    The right to request access to Personal Data relating to the data subject.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>The right to rectification or erasure.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>The right to object.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>The right to request restriction of processing.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>The right to data portability.</ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    The right not to be subject to decisions based solely on automated processing of Personal Data.
                                </ListItem>
                            </List>

                            <Typography variant="body1" paragraph>
                                Subjects of the Personal Data obtained may exercise their personal data protection rights by sending a
                                written communication to TREKZY&apos;s registered office or to the email address{' '}
                                <Link href="mailto:datospersonales@trekzy.com">datospersonales@trekzy.com</Link>.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Forms, templates, and more information about your rights are available on the website of the national
                                supervisory authority, the Spanish Data Protection Agency (AEPD),{' '}
                                <Link href="https://www.aepd.es" target="_blank" rel="noopener">
                                    www.aepd.es
                                </Link>
                                .
                            </Typography>

                            <Typography variant="body1" paragraph>
                                TREKZY will respond within one month of receiving your request, and in exceptional cases, this period may
                                be extended for up to two months.
                            </Typography>
                        </Section>

                        <Section title="CAN I WITHDRAW CONSENT?">
                            <Typography variant="body1" paragraph>
                                You have the right to withdraw consent for any specific purpose granted at the time, without affecting the
                                lawfulness of the processing based on the consent prior to its withdrawal.
                            </Typography>
                        </Section>

                        <Section title="WHERE CAN I FILE A COMPLAINT IF I FEEL THAT MY PERSONAL DATA IS NOT BEING PROCESSED CORRECTLY?">
                            <Typography variant="body1" paragraph>
                                If any data subject believes that their Personal Data is not being processed correctly by TREKZY, or that
                                their requests to exercise their rights have not been satisfactorily addressed, they may file a complaint
                                with the appropriate data protection authority. The AEPD is the Spanish Data Protection Agency (AEPD) at{' '}
                                <Link href="https://www.aepd.es" target="_blank" rel="noopener">
                                    www.aepd.es
                                </Link>
                                .
                            </Typography>
                        </Section>

                        <Section title="SECURITY AND UPDATING OF YOUR PERSONAL DATA">
                            <Typography variant="body1" paragraph>
                                In order to safeguard the security of your Personal Data, we inform you that TREKZY has adopted all
                                necessary technical and organizational measures to guarantee the security of the Personal Data provided.
                                This is done to prevent its alteration, loss, and/or unauthorized processing or access, as required by law,
                                although absolute security does not exist.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                It is important that, so that we can keep your Personal Data up to date, you inform us whenever it changes.
                            </Typography>
                        </Section>

                        <Section title="INTERNATIONAL TRANSFERS">
                            <ListItemHeader>
                                CLIENTS/POTENTIAL CUSTOMERS/WEBSITE USERS:
                            </ListItemHeader>
                            <Typography variant="body1" paragraph>
                                For the purposes indicated in this Privacy Policy, TREKZY does not transfer Personal Data outside the
                                European Union.
                            </Typography>

                            <ListItemHeader>
                                SUPPLIERS/CANDIDATES/EMPLOYEES:
                            </ListItemHeader>
                            <Typography variant="body1" paragraph>
                                For the management and administration purposes indicated in this Privacy Policy, TREKZY transfers your
                                personal data outside the European Union to the United Mexican States.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                Since the destination of the transfer has not received an adequacy decision from the European Commission,
                                TREKZY has adopted measures with the recipient of your personal data, Amigo Group Europa, S.L., to ensure an
                                adequate level of protection for this information. These measures consist of the parties entering into
                                standard contractual clauses for data protection adopted by the European Commission. You can obtain a copy
                                of the public version of these adequate safeguards by sending a request to{' '}
                                <Link href="mailto:datospersonales@trekzy.com">datospersonales@trekzy.com</Link>.
                            </Typography>
                        </Section>

                        <Section title="CONFIDENTIALITY">
                            <Typography variant="body1" paragraph>
                                TREKZY informs you that your Personal Data will be treated with the utmost care and confidentiality by all
                                personnel involved in any phase of the processing. We will not transfer or communicate your data to any
                                third party, except as provided by law, or unless the data subject has expressly authorized us to do so.
                            </Typography>
                        </Section>

                        <Section title="MODIFICATIONS AND UPDATES TO THIS PRIVACY POLICY">
                            <Typography variant="body1" paragraph>
                                TREKZY may modify, expand, correct, or update this Privacy Policy at any time and under its sole
                                responsibility. In all cases, we will publish the date this Privacy Policy was last updated on the Website.
                            </Typography>

                            <Typography variant="body1" paragraph>
                                We may communicate these changes through the Website or by sending an email if we have your address, but we
                                are not obligated to do so.
                            </Typography>
                        </Section>

                        <Divider sx={{ my: 4 }} />

                        <Typography variant="body2" color="text.secondary" paragraph>
                            Last updated: December 4, 2024
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                            Pasaje de Bisbal 6, 28028, Madrid (España)
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            <Link href="https://www.trekzy.com" target="_blank" rel="noopener">
                                www.trekzy.com
                            </Link>
                        </Typography>
                    </Box>
                </StaticPagesWrapper>
            </MainLayout>
        );
    }
}

export default PrivacyPolicies
